import { SYSTEM_ROLES } from 'lib/rbac/systemRoles'

type RoleOption = {
  label: string
  value: string
  description: string
}

export const ROLE_OPTIONS: RoleOption[] = [
  {
    label: 'Admin',
    value: SYSTEM_ROLES.admin,
    description: 'Manage and view all data, settings and users.'
  },
  {
    label: 'Finance user',
    value: SYSTEM_ROLES.financeUser,
    description:
      'Create and manage billing, invoices, customers, and revenue. Can view all data and invite other users.'
  },
  {
    label: 'Sales user',
    value: SYSTEM_ROLES.salesUser,
    description:
      'Create and manage quotes and customers. Can view all data and invite other users.'
  },
  {
    label: 'View only',
    value: SYSTEM_ROLES.readOnlyUser,
    description: 'View all data and reports.'
  }
]

export const ROLE_SELECTION_HELP_TEXT =
  'Assign roles to grant members appropriate permissions,'

export const ROLE_DOCS_URL =
  'https://docs.sequencehq.com/users/roles-permissions'

export type { RoleOption }
